module.exports = __webpack_public_path__ + "img/157.c04bd194.jpg";